import axios from 'axios';
import { message } from 'ant-design-vue';

const isProduction = 'production' === process.env.NODE_ENV;

const host = 'test.aivideo8.com';
// const host ='www.video.com';

const url = isProduction ? '/api/' : `http://${host}/api/`;

let done
try {
  done = process.env?.TEST_LIFISHER ;
} catch(e) {
  done = 'true'
}
let getTokenPromise;

const internalGetToken = async () => {
  let token;
  const credentials = process.env.CREDENTIALS;
  console.info('credentials', credentials)
  const res = await axios.post(url + 'login', credentials);
  token = res.data.token ? res.data.token : res.data.data.token;
  token = (await axios.post(url + 'user/confirm_login', { token })).data.token;
  localStorage.setItem('token', token);
  return token;
};

// let prevToken = '';

export const getToken = async () => {
  if (isProduction) {
    let ret = '';
    document.cookie.replace(/token=([^;]+)/, (_, encoded) => {
      ret = atob(encoded);
      // if (!prevToken) {
      //   prevToken = ret;
      // } else if (ret !== prevToken) {
      //   throw new Error('token mismatch');
      // }
    });
    return ret;
  }if (isProduction) {
    let ret = '';
    document.cookie.replace(/token=([^;]+)/, (_, encoded) => {
      ret = atob(encoded);
      // if (!prevToken) {
      //   prevToken = ret;
      // } else if (ret !== prevToken) {
      //   throw new Error('token mismatch');
      // }
    });
    return ret;
  }
  let token;
  if (done) {
    token = localStorage.getItem('token');
  }
  if (!token) {
    if (getTokenPromise) {
      return getTokenPromise;
    }
    getTokenPromise = internalGetToken();
    token = await getTokenPromise;
    done = true;
  }
  return token;
};

const request = async (method = 'get', path = '', payload = {}, withToken = false, done) => {
  const token = await getToken();
  let res;
  try {
    res = await axios.request({
      url: url + path,
      method,
      headers: { Authorization: token },
      data: method !== 'get' ? { ...payload, token: withToken ? token : undefined } : undefined,
      params: method !== 'get' ? undefined : payload
    });
  } catch (e) {
    message.error(e && (e.message || e));
    throw e;
  }
  if (res.data.status !== 1) {
    message.error(res.data.msg);
    if (res.data.status === 10001) {
      localStorage.clear();
      document.cookie = "token=; path=/";
      window.location.href = '/login';
    }
    throw new Error(res.data.msg);
  }
  if (typeof done === 'function') {
    done(res);
  }
  return res.data.data;
};

export const post = async (path, data, withToken, done) => {
  return request('post', path, data, withToken, done);
};

export const get = async (path, params, done) => {
  return request('get', path, params, false, done);
};

/**
 * @deprecated
 */
export const uploadFile = async (files, fn) => {
  const formData = new FormData();
  formData.append('file', files[0]);
  const token = await getToken();
  const res = await axios.post(url + 'oss', formData, {
    headers: {
      Authorization: token,
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress: progressEvent => {
      fn(progressEvent);
    }
  });
  if (res.data.status !== 1) {
    message.error(res.data.msg);
    throw res.data.msg;
  }
  return res.data.data;
};

export const uploadFile2 = async (file, progressFn) => {
  const res = await post('get-sign-material', {
    filename: file.name
  });
  let signObj = {
    name: file.name,
    key: res.object_name,
    policy: res.policy,
    OSSAccessKeyId: res.accessid,
    success_action_status: '200',
    signature: res.signature,
    file
  };
  let formdata = new FormData();
  for (let key in signObj) {
    formdata.append(key, signObj[key]);
  }
  await axios.post(res.host, formdata, {
    onUploadProgress: progressEvent => {
      if (progressFn) {
        let complete = (progressEvent.loaded / progressEvent.total * 100 | 0);
        progressFn(complete);
      }
    }
  });
  return {
    url: res.host + res.object_name
  };
};

export async function getSVGData(file) {
  const resp = await axios.get(file);
  console.log(resp);
  return resp;
}

export function addClickCount(id, lottie) {
  return post(lottie ? 'lottie/click' : 'assembly/click', { id });
}